<template>
  <div class="MerchandisePage">
    <Banners page="merchandise" />
    <div v-if="$route.params.category">{{ $route.params.category }}</div>

    <div>
      <Breadcrumb v-if="$route.name !== 'home'">
        <span>{{ getNavName(navName) }}</span>
      </Breadcrumb>

      <CategorySelector> </CategorySelector>
    </div>
    <ProductList v-if="products.length !== 1"></ProductList>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ProductList from '../Products/ProductList.vue';
import Breadcrumb from '../Breadcrumbs.vue';
import CategorySelector from './CategorySelector.vue';
import Banners from '../Banners/Banners.vue';

export default {
  name: 'MerchandiseComponent',
  components: {
    ProductList,
    Breadcrumb,
    CategorySelector,
    Banners,
  },
  data() {
    return {
      navName: '',
    };
  },
  props: {
    kind: { required: false },
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
      navTranslations: (state) => state.app.navTranslations,
      products: (state) => state.products.data,
    }),
  },
  methods: {
    ...mapActions({
      getProducts: 'products/get',
    }),
    getNavName(type) {
      if (typeof this.navTranslations !== 'undefined') {
        if (typeof this.navTranslations[type] !== 'undefined') {
          if (
            typeof this.navTranslations[type][this.language] !== 'undefined' &&
            this.navTranslations[type][this.language] !== ''
          ) {
            return this.navTranslations[type][this.language];
          }
        }
      }
      return this.$t(type);
    },
  },
  mounted() {
    this.navName = this.getNavName('NAV_MERCHANDISE');
    if (this.$route.name === 'passes') {
      this.navName = this.getNavName('NAV_MEMCARD');
    }
    if (this.$route.name === 'passes' || this.kind === 'passes') {
      this.getProducts({ product_kind: 13 }).then(() => {
        if (this.products.length === 1) {
          this.$router.replace({ name: 'product', params: { id: this.products[0].id } });
        }
      });
    } else {
      this.getProducts().then(() => {
        if (this.products.length === 1) {
          this.$router.replace({ name: 'product', params: { id: this.products[0].id } });
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped></style>
